module.exports = __webpack_public_path__ + "img/footer_bg1.2da8fe04.png";